// BISCertification.jsx
import React from "react";

export default function BISCertification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            BIS Certification
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            BIS Certification for Product Safety & Standards
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides expert assistance for BIS
            Certification to ensure products comply with Bureau of Indian
            Standards regulations and safety norms under CRS and ISI schemes.
          </p>
          <p className="text-gray-700">
            From product standard identification and lab testing coordination to
            factory audit preparation, application submission, and license
            issuance through BIS portal, the process ensures market compliance.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: BIS quality testing laboratory) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/356056/pexels-photo-356056.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="BIS quality testing laboratory and certification compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for BIS Certification
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps manufacturers organize complete
              technical documentation for BIS CRS/ISI certification schemes.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Business registration certificate (GST, incorporation, or partnership deed).</li>
                <li>
                  Product details and specifications including technical
                  drawings, IS standard compliance, and model variants.
                </li>
                <li>
                  Manufacturing unit information covering layout plans, process
                  flow, quality control systems, and infrastructure details.
                </li>
                <li>Test reports from BIS-approved NABL accredited laboratories.</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm provides comprehensive BIS certification support across
              electronics, steel, chemicals, and consumer goods categories.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  BIS Regulatory Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete knowledge of CRS, ISI Mark, Scheme-X, and FMCS
                  requirements across notified product categories and Indian
                  Standards compliance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise BIS portal applications, test report validation, factory
                  audit preparation, and complete documentation packages for
                  streamlined certification process.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  End-to-End Certification Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Full assistance from product categorization and lab testing
                  coordination through factory inspection, license grant, and
                  ongoing surveillance compliance advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
